import { useEffect, useState } from 'react'
import { TCanvas } from '.'
import { TDesignSide, TEditorConfig } from '../editor.types'
import {
  checkForLegacyCanvasConfig,
  getInitialCanvasConfig,
} from './canvas.utils'
import { TOnlineEditorConfiguration } from '../../designUpload/types'
import {
  mapProductSpecsToCanvas,
  getColorPickerKeys,
  getResetCanvasColors,
} from '../editor.utils'

export function useCanvasConfig({
  preloadedOnlineEditorConfig,
  editorConfig,
}: {
  preloadedOnlineEditorConfig: TOnlineEditorConfiguration
  editorConfig: TEditorConfig
}) {
  const [canvasConfig, setCanvasConfig] = useState<
    Record<TDesignSide, TCanvas>
  >(
    checkForLegacyCanvasConfig(
      preloadedOnlineEditorConfig?.canvasConfig,
      preloadedOnlineEditorConfig?.widgets
    ) || {
      front: getInitialCanvasConfig({ editorConfig }),
      back: getInitialCanvasConfig({ editorConfig }),
    }
  )
  //  On product dimesions change
  useEffect(() => {
    const sizeUpdates = mapProductSpecsToCanvas(editorConfig)

    const colorsPickersToInclude = getColorPickerKeys(
      editorConfig?.productColorConfig
    )

    const colorUpdates = getResetCanvasColors({
      enabledPickers: colorsPickersToInclude,
      material: editorConfig?.material,
      productColorOption: editorConfig?.productColorOption,
    })

    const updatedCanvasConfig = {
      front: {
        ...canvasConfig?.front,
        ...sizeUpdates,
        ...colorUpdates,
      },
      back: {
        ...canvasConfig?.back,
        ...sizeUpdates,
        ...colorUpdates,
      },
    }

    setCanvasConfig(updatedCanvasConfig)
  }, [editorConfig])

  return {
    canvasConfig,
    setCanvasConfig,
  }
}
